module.exports = __webpack_public_path__ + "img/teacher-pic003.9365448e.png";